import { useCallback, useEffect, useState } from 'react';
import { REFERENCE_IMAGE } from '../../../constants/template-builder';
export function useReferenceImage() {
  const [backgroundImage, setBackgroundImage] = useState<string | null>(null);
  const [imageOpacity, setImageOpacity] = useState<number>(REFERENCE_IMAGE.DEFAULT_OPACITY);
  useEffect(() => {
    return () => {
      if (backgroundImage) {
        URL.revokeObjectURL(backgroundImage);
      }
    };
  }, [backgroundImage]);
  const handleImageSelect = useCallback((imageUrl: string) => {
    if (backgroundImage) {
      URL.revokeObjectURL(backgroundImage);
    }
    setBackgroundImage(imageUrl);
  }, [backgroundImage]);
  const handleRemoveImage = useCallback(() => {
    if (backgroundImage) {
      URL.revokeObjectURL(backgroundImage);
    }
    setBackgroundImage(null);
    setImageOpacity(REFERENCE_IMAGE.DEFAULT_OPACITY);
  }, [backgroundImage]);
  return {
    backgroundImage,
    imageOpacity,
    setImageOpacity,
    handleImageSelect,
    handleRemoveImage
  };
}